var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable no-var */
import { isEmpty } from "lodash";
import { useCallback, useContext, useEffect, useState } from "react";
import Modal from "react-modal";
import { createVttOrder, getSliceLimit, modifyVttOrder, } from "src/apis/dashboard";
const { REACT_APP_URL_ASSET_BASE_PATH } = process.env;
// import DepthChart from "src/components/depth-chart/depth";
import StepNumberInput from "src/components/inputs/step-number-input";
import SwitchButton from "src/components/switch-button/switch";
import { useAppDispatch } from "src/hooks/redux";
import { refreshNetPosition } from "src/redux/reducers/common-reducer";
import { DECIMAL_LENGTH_LIMIT } from "src/utils/constant";
import { getChangeAndChangePercentage, handleDecimalLimit, } from "src/utils/methods";
import { SESSION_KEYS, getDataFromSession } from "src/utils/session-storage";
import styles from "./buyform.module.scss";
import { PricePickerContext } from "src/contexts/custom-context";
const componentName = "VttForm";
const VttBuyForm = ({ productType, timeType, scripData, lotSize, scripPriceData, formType, returnValue, execute, executeCallback, isFormValid, isLoading: isLoadingBuyform, isBuyForm, fetchSetting, }) => {
    var _a;
    const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
    const dispatch = useAppDispatch();
    const [addStoplossExpand, setAddStoplossExpand] = useState(false);
    const [addTargetExpand, setAddTargetExpand] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [disQtyErrorMessage, setDisQtyErrorMessage] = useState("");
    const [priceType, setPriceType] = useState("market");
    const [price, setPrice] = useState("0");
    const [priceErrorMessage, setPriceErrorMessage] = useState("");
    const [initialTriggerPrice, setInitialTriggerPrice] = useState("0");
    const [itpErrorMessage, setItpErrorMessage] = useState("");
    const [targetPrice, setTargetPrice] = useState("0");
    const [targetTriggerPrice, setTargetTriggerPrice] = useState("0");
    const [ttpErrorMessage, setTtpErrorMessage] = useState("");
    const [stopLossTriggerPrice, setStopLossTriggerPrice] = useState("0");
    const [sltErrorMessage, setSltErrorMessage] = useState("");
    const [stopLossPrice, setStopLossPrice] = useState("0");
    // const [slpErrorMessage, setSlpErrorMessage] = useState("");
    const [stopLossPriceType, setStopLossPriceType] = useState("market");
    const [targetPriceType, setTargetPriceType] = useState("market");
    const [isLegOrder, setLegOrder] = useState(false);
    const [stockQuantity, setStockQuantity] = useState(0);
    const [stockQtyErrorMessage, setStockQtyErrorMessage] = useState("");
    const [validationErrorMessage, setValidationErrorMessage] = useState(undefined);
    const setStockQuantityCallback = useCallback((newValue, isInput = false) => {
        if (newValue != stockQuantity && newValue > 0) {
            if (fetchSetting.qty && !isInput) {
                const newQuantity = fetchSetting.key == "fno"
                    ? fetchSetting.qty * lotSize
                    : fetchSetting.qty;
                if (newQuantity !== stockQuantity) {
                    setStockQuantity(newQuantity);
                }
            }
            else {
                setStockQuantity(newValue);
            }
        }
    }, [stockQuantity, lotSize, fetchSetting.qty]);
    const { picker, setPicker } = useContext(PricePickerContext);
    // Fetching/Getting the API Data from Market Depth
    const getPercentageCalculation = useCallback((numerator, denominator) => {
        const difference = Math.abs(numerator - denominator);
        return ((difference * 100) / denominator).toFixed(2);
    }, []);
    const getCreateVttOrderReqJson = () => {
        return {
            clientCode: clientCode,
            exchange: scripData.exchange,
            exchangeType: scripData.exchangeType,
            scripCode: scripData.scripCode,
            // price: price,
            stopLossPrice: addStoplossExpand && stopLossPriceType == "limit"
                ? parseFloat(stopLossPrice) * 100
                : 0,
            price: parseFloat(initialTriggerPrice),
            initialTriggerPrice: Number((parseFloat(initialTriggerPrice) * 100).toFixed()),
            stopLossTriggerPrice: addStoplossExpand
                ? parseFloat(stopLossTriggerPrice) * 100
                : 0,
            profitLimitPrice: addTargetExpand && targetPriceType == "limit"
                ? parseFloat(targetPrice) * 100
                : 0,
            profitTriggerPrice: addTargetExpand
                ? parseFloat(targetTriggerPrice) * 100
                : 0,
            quantity: stockQuantity,
            stockQuantity: stockQuantity,
            buySell: formType,
            matchingCondition: parseFloat(initialTriggerPrice) < scripPriceData.lastTradePrice
                ? "LT"
                : "GT",
            symbol: scripData.name,
        };
    };
    useEffect(() => {
        onPriceChange(picker.price + "");
        setPriceType(picker.type);
    }, [picker.price]);
    useEffect(() => {
        returnValue(getCreateVttOrderReqJson());
        isFormValid(isFormValidCallback());
    }, [
        price,
        addStoplossExpand,
        stopLossPriceType,
        stopLossPrice,
        initialTriggerPrice,
        stopLossTriggerPrice,
        addTargetExpand,
        targetPriceType,
        targetPrice,
        targetTriggerPrice,
        stockQtyErrorMessage,
        itpErrorMessage,
        sltErrorMessage,
        ttpErrorMessage,
        priceErrorMessage,
        isLoading,
        stockQuantity,
        scripData.exchange,
        scripData.exchangeType,
        scripData.scripCode,
        scripData.name,
        formType,
        scripPriceData.lastTradePrice,
    ]);
    const checkAndSetValidationErrorMessage = () => {
        setValidationErrorMessage(undefined);
        if ((parseFloat(stopLossTriggerPrice) <= 0 || sltErrorMessage != "") &&
            addStoplossExpand) {
            setValidationErrorMessage(sltErrorMessage);
            return false;
        }
        else if ((parseFloat(targetTriggerPrice) <= 0 || ttpErrorMessage != "") &&
            addTargetExpand) {
            setValidationErrorMessage(ttpErrorMessage);
            return false;
        }
        return true;
    };
    const isFormValidCallback = useCallback(() => {
        if (isLoading) {
            return false;
        }
        else if (stockQtyErrorMessage != "") {
            return false;
        }
        else if (priceErrorMessage != "") {
            return false;
        }
        else if (itpErrorMessage != "") {
            return false;
        }
        else {
            return true;
        }
    }, [
        isLoading,
        stockQtyErrorMessage,
        priceErrorMessage,
        itpErrorMessage,
        addStoplossExpand,
        stopLossTriggerPrice,
        sltErrorMessage,
        addTargetExpand,
        targetTriggerPrice,
        ttpErrorMessage,
    ]);
    const getSliceLimitCallback = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield getSliceLimit(scripData.exchange, scripData.exchangeType, scripData.scripCode);
        // response.data.body.Qtylimit;
        // response.data.body.SliceEnable;
    }), [scripData]);
    useEffect(() => {
        if (stockQuantity <= 0) {
            setStockQuantityCallback(lotSize);
        }
    }, [lotSize, stockQuantity]);
    useEffect(() => {
        setStockQuantityCallback(fetchSetting.qty);
    }, [scripData]);
    useEffect(() => {
        onPriceTypeChange(fetchSetting.priceType);
    }, [fetchSetting]);
    useEffect(() => {
        var _a;
        if (scripData.vttOrderDetail) {
            if (scripData.vttOrderDetail.InitialOrderStatus &&
                scripData.orderFor == "M") {
                const isLegOrderLocal = (_a = scripData.vttOrderDetail) === null || _a === void 0 ? void 0 : _a.InitialOrderStatus.includes("Triggered");
                setLegOrder(isLegOrderLocal);
            }
        }
        else {
            setStockQuantityCallback(lotSize);
        }
    }, [scripData, lotSize]);
    const setInitialTriggerPriceCallBack = useCallback((event) => {
        setInitialTriggerPrice(handleDecimalLimit(event, DECIMAL_LENGTH_LIMIT));
    }, []);
    const setItpErrorMessageCallBack = useCallback(() => {
        let errorMessage = "";
        if (isEmpty(initialTriggerPrice)) {
            errorMessage = "Trigger price is compulsory";
        }
        else if (parseFloat(initialTriggerPrice) <= 0) {
            errorMessage = "Trigger price should be greater than zero";
        }
        // else if (priceType == "limit") {
        //   if (
        //     formType == "BUY" &&
        //     parseFloat(initialTriggerPrice) >= parseFloat(price)
        //   ) {
        //     errorMessage = "Trigger price cannot be greater than or equal to price";
        //   } else if (
        //     formType == "SELL" &&
        //     parseFloat(initialTriggerPrice) <= parseFloat(price)
        //   ) {
        //     errorMessage = "Trigger price cannot be less than or equal to price";
        //   }
        // }
        setItpErrorMessage(errorMessage);
    }, [formType, initialTriggerPrice, price, priceType]);
    //================================Quantity and above close=======================
    const onAddStoplossChange = useCallback((isChecked) => {
        setAddStoplossExpand(isChecked);
    }, []);
    const onAddTargetChange = useCallback((isChecked) => {
        setAddTargetExpand(isChecked);
        // if (isChecked && !addStoplossExpand) {
        //   setAddStoplossExpand(true);
        // }
    }, [addStoplossExpand]);
    const setStopLossTriggerCallback = useCallback((event) => {
        setStopLossTriggerPrice(handleDecimalLimit(event, DECIMAL_LENGTH_LIMIT));
    }, []);
    const setSltErrorMessageCallback = useCallback(() => {
        let errorMessage = "";
        const comparisonPrice = isLegOrder
            ? scripPriceData.lastTradePrice
            : parseFloat(initialTriggerPrice);
        if (isEmpty(stopLossTriggerPrice)) {
            errorMessage = "Stoploss Trigger Price is compulsory";
        }
        else if (stopLossTriggerPrice == "0") {
            errorMessage = "Stoploss trigger Price should be greater than 0";
        }
        else if (isEmpty(stopLossPrice)) {
            errorMessage = "Stop loss is compulsory";
        }
        else if (formType == "BUY" &&
            parseFloat(stopLossTriggerPrice) >= comparisonPrice) {
            errorMessage = `SL Trigger price should be less than Trigger price`;
        }
        else if (formType == "SELL" &&
            parseFloat(stopLossTriggerPrice) <= comparisonPrice) {
            errorMessage = `SL trigger should be greater than Trigger price`;
        }
        else if (stopLossPriceType == "limit") {
            if (formType == "BUY" &&
                parseFloat(stopLossTriggerPrice) < parseFloat(stopLossPrice)) {
                errorMessage = "SL Price should be less than Stoploss Trigger price";
            }
            else if (formType == "BUY" &&
                parseFloat(stopLossTriggerPrice) === parseFloat(stopLossPrice)) {
                errorMessage = "SL Limit price cannot be same as SL Trigger price";
            }
            else if (formType == "SELL" &&
                parseFloat(stopLossTriggerPrice) > parseFloat(stopLossPrice)) {
                errorMessage = "SL price should be greater than Stoploss Trigger price";
            }
            else if (formType == "SELL" &&
                parseFloat(stopLossTriggerPrice) === parseFloat(stopLossPrice)) {
                errorMessage = "SL Limit price cannot be same as SL Trigger price";
            }
            else {
                // TODO document why this block is empty
                //We dont to add condition as error message will be empty
            }
        }
        setSltErrorMessage(errorMessage);
    }, [
        formType,
        initialTriggerPrice,
        stopLossPrice,
        stopLossPriceType,
        stopLossTriggerPrice,
        isLegOrder,
    ]);
    const setTtpErrorMessageCallback = useCallback(() => {
        let errorMessage = "";
        if (isEmpty(targetTriggerPrice)) {
            errorMessage = "Target trigger price is compulsory";
        }
        else if (isEmpty(targetPrice)) {
            errorMessage = "Target price is compulsory";
        }
        else if (targetTriggerPrice === "0") {
            errorMessage = "Target Trigger price should be greater than 0";
        }
        else if (formType == "BUY" &&
            parseFloat(targetTriggerPrice) <= parseFloat(initialTriggerPrice)) {
            errorMessage =
                "Target Trigger price should be greater than Trigger price";
        }
        else if (formType == "SELL" &&
            parseFloat(targetTriggerPrice) >= parseFloat(initialTriggerPrice)) {
            errorMessage = "Target Trigger price should be less than Trigger price";
        }
        else if (targetPriceType == "limit") {
            if (isEmpty(errorMessage)) {
                if (formType == "BUY" &&
                    parseFloat(targetPrice) < parseFloat(targetTriggerPrice)) {
                    errorMessage =
                        "Target price should be greater than Target Trigger price";
                }
                else if (formType == "BUY" &&
                    parseFloat(targetPrice) === parseFloat(targetTriggerPrice)) {
                    errorMessage =
                        "Target Limit price cannot be same as Target Trigger price";
                }
                else if (formType == "SELL" &&
                    parseFloat(targetPrice) > parseFloat(targetTriggerPrice)) {
                    errorMessage =
                        "Target price should be less than Target Trigger price";
                }
                else if (formType == "SELL" &&
                    parseFloat(targetPrice) === parseFloat(targetTriggerPrice)) {
                    errorMessage =
                        "Target Limit price cannot be same as Target Trigger price";
                }
                // if (
                //   formType == "BUY" &&
                //   parseFloat(targetTriggerPrice) >= parseFloat(targetPrice)
                // ) {
                //   errorMessage =
                //     "Target trigger price should be less than target price";
                // } else if (
                //   formType == "SELL" &&
                //   parseFloat(targetTriggerPrice) <= parseFloat(targetPrice)
                // ) {
                //   errorMessage =
                //     "Target trigger price should be less than target price";
                // }
            }
        }
        setTtpErrorMessage(errorMessage);
    }, [
        formType,
        initialTriggerPrice,
        targetPrice,
        targetPriceType,
        targetTriggerPrice,
    ]);
    useEffect(() => {
        setSltErrorMessageCallback();
        setItpErrorMessageCallBack();
        setTtpErrorMessageCallback();
    }, [
        formType,
        initialTriggerPrice,
        stopLossPrice,
        stopLossPriceType,
        stopLossTriggerPrice,
        price,
        priceType,
        targetPrice,
        targetPriceType,
        targetTriggerPrice,
        isLegOrder,
        scripData,
        setSltErrorMessageCallback,
        setItpErrorMessageCallBack,
        setTtpErrorMessageCallback,
    ]);
    const onPriceChange = useCallback((priceValue) => {
        setPrice(handleDecimalLimit(priceValue, DECIMAL_LENGTH_LIMIT));
    }, []);
    const onPriceTypeChange = useCallback((type) => {
        if (priceType != type) {
            setPriceType(type);
            if (type == "limit") {
                onPriceChange(scripPriceData.lastTradePrice + "");
            }
            else {
                onPriceChange("0");
            }
        }
    }, [priceType, scripPriceData.lastTradePrice]);
    const [showChart, setShowChart] = useState(false);
    const onEditMarketChange = useCallback(() => {
        setShowChart(!showChart);
    }, [showChart]);
    const setStopLossPriceCallBack = useCallback((event) => {
        setStopLossPrice(handleDecimalLimit(event, DECIMAL_LENGTH_LIMIT));
    }, []);
    const onStopLossPriceTypeChange = useCallback((type) => {
        if (stopLossPriceType != type) {
            setStopLossPriceType(type);
            if (type == "market") {
                setStopLossPriceCallBack("0");
            }
            else {
                setStopLossPriceCallBack(scripPriceData.lastTradePrice + "");
            }
        }
    }, [stopLossPriceType, setStopLossPriceCallBack, scripPriceData.lastTradePrice]);
    const setTargetPriceCallBack = useCallback((event) => {
        setTargetPrice(handleDecimalLimit(event, DECIMAL_LENGTH_LIMIT));
    }, []);
    const onTargePriceTypeChange = useCallback((type) => {
        if (targetPriceType != type) {
            setTargetPriceType(type);
            if (type == "market") {
                setTargetPriceCallBack("0");
            }
            else {
                setTargetPriceCallBack(scripPriceData.lastTradePrice + "");
            }
        }
    }, [targetPriceType, setTargetPriceCallBack, scripPriceData.lastTradePrice]);
    const setTargetPriceTriggerCallBack = useCallback((event) => {
        setTargetTriggerPrice(handleDecimalLimit(event, DECIMAL_LENGTH_LIMIT));
    }, []);
    const changePriceValues = getChangeAndChangePercentage(scripPriceData.lastTradePrice, scripPriceData.previousClose);
    const modifyVttOrderCallBack = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        setLoading(true);
        const request = {
            clientCode,
            orderId: (_b = scripData.vttOrderDetail) === null || _b === void 0 ? void 0 : _b.VTTOrderId,
            price: parseFloat(price) * 100,
            stopLossPrice: addStoplossExpand && stopLossPriceType == "limit"
                ? parseFloat(stopLossPrice) * 100
                : 0,
            initialTriggerPrice: Number((parseFloat(initialTriggerPrice) * 100).toFixed()),
            stopLossTriggerPrice: addStoplossExpand
                ? parseFloat(stopLossTriggerPrice) * 100
                : 0,
            profitLimitPrice: addTargetExpand && targetPriceType == "limit"
                ? parseFloat(targetPrice) * 100
                : 0,
            profitTriggerPrice: addTargetExpand
                ? parseFloat(targetTriggerPrice) * 100
                : 0,
            quantity: stockQuantity,
            matchingCondition: parseFloat(initialTriggerPrice) < scripPriceData.lastTradePrice
                ? "LT"
                : "GT",
        };
        try {
            const response = yield modifyVttOrder(request);
            if (response.data.body.RMSStatus == 0 || response.data.body.Status == 0) {
                executeCallback(true, "Order modified successfully");
            }
            else {
                executeCallback(false, response.data.body.Message);
            }
        }
        catch (error) {
            console.error(error);
            executeCallback(false, "Something went wrong");
        }
        finally {
            setLoading(false);
        }
    }), [
        addStoplossExpand,
        addTargetExpand,
        initialTriggerPrice,
        price,
        (_a = scripData.vttOrderDetail) === null || _a === void 0 ? void 0 : _a.VTTOrderId,
        scripPriceData.lastTradePrice,
        stockQuantity,
        stopLossPrice,
        stopLossPriceType,
        stopLossTriggerPrice,
        targetPrice,
        targetPriceType,
        targetTriggerPrice,
    ]);
    const createVttOrderCallback = () => __awaiter(void 0, void 0, void 0, function* () {
        if (scripData.orderFor == "M") {
            return modifyVttOrderCallBack();
        }
        setLoading(true);
        const request = Object.assign({}, getCreateVttOrderReqJson());
        request.price = Number(price) * 100;
        try {
            const response = yield createVttOrder(request);
            // dispatch(marginUpdate(true));
            if (response.data.body.RMSStatus == 0 || response.data.body.Status == 0) {
                executeCallback(true, "Order placed successfully");
            }
            else {
                executeCallback(false, response.data.body.Message);
            }
            dispatch(refreshNetPosition(true));
        }
        catch (error) {
            executeCallback(false, "Something went wrong");
        }
        finally {
            setLoading(false);
        }
    });
    useEffect(() => {
        if (execute) {
            if (checkAndSetValidationErrorMessage()) {
                createVttOrderCallback();
            }
            else {
                executeCallback(false, undefined);
            }
        }
    }, [execute]);
    useEffect(() => {
        if (priceType == "limit") {
            if (isEmpty(price)) {
                setPriceErrorMessage("Price is compulsory.");
            }
            else if (parseFloat(price) <= 0) {
                setPriceErrorMessage("Price should be greater than zero.");
            }
            else if (formType == "BUY" &&
                parseFloat(price) < parseFloat(initialTriggerPrice)) {
                setPriceErrorMessage("Limit price should be greater than Trigger price!");
            }
            else if (formType == "BUY" &&
                parseFloat(price) === parseFloat(initialTriggerPrice)) {
                setPriceErrorMessage("Limit price cannot be same as initial Trigger price!");
            }
            else if (formType == "SELL" &&
                parseFloat(price) > parseFloat(initialTriggerPrice)) {
                setPriceErrorMessage("Limit price should be less than Trigger price!");
            }
            else if (formType == "SELL" &&
                parseFloat(price) === parseFloat(initialTriggerPrice)) {
                setPriceErrorMessage("Limit price cannot be same as initial Trigger price!");
            }
            else {
                setPriceErrorMessage("");
            }
        }
        else {
            setPriceErrorMessage("");
        }
    }, [price, priceType, formType, initialTriggerPrice]);
    //modify data
    useEffect(() => {
        if (scripData.vttOrderDetail) {
            setStockQuantityCallback(scripData.vttOrderDetail.Quantity);
            if (scripData.vttOrderDetail.InitialLimitPrice != 0) {
                onPriceTypeChange("limit");
                onPriceChange(scripData.vttOrderDetail.InitialLimitPrice + "");
            }
            setInitialTriggerPriceCallBack(scripData.vttOrderDetail.InitialTriggerPrice + "");
            if (parseFloat(scripData.vttOrderDetail.ProfitTriggerPrice) > 0 ||
                scripData.vttOrderDetail.ProfitLimitPrice > 0) {
                setAddTargetExpand(true);
                setTargetPriceTriggerCallBack(scripData.vttOrderDetail.ProfitTriggerPrice);
                if (scripData.vttOrderDetail.ProfitLimitPrice != 0) {
                    onTargePriceTypeChange("limit");
                    setTargetPriceCallBack(scripData.vttOrderDetail.ProfitLimitPrice + "");
                }
            }
            if (scripData.vttOrderDetail.StopLossLimitPrice > 0 ||
                scripData.vttOrderDetail.StopLossTriggerPrice > 0) {
                setAddStoplossExpand(true);
                if (scripData.vttOrderDetail.StopLossLimitPrice != 0) {
                    onStopLossPriceTypeChange("limit");
                    setStopLossPriceCallBack(scripData.vttOrderDetail.StopLossLimitPrice + "");
                }
                setStopLossTriggerCallback(scripData.vttOrderDetail.StopLossTriggerPrice + "");
            }
        }
        // getSliceLimitCallback();
    }, [scripData]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: `${styles.priceInputWrapper} d-flex justify-content-between align-items-start` }, { children: [_jsx("div", Object.assign({ className: `${styles.stepInputBuyform}` }, { children: _jsx(StepNumberInput, { isFocus: true, formType: formType, productType: productType, timeType: timeType, inputLabel: "Quantity", defaultValue: stockQuantity, placeholder: false, stepInput: lotSize, errorMessage: "Invalid Quantity", errorMessageCallback: (errMsg) => {
                                setStockQtyErrorMessage(errMsg);
                            }, disabled: isLoadingBuyform || isLegOrder, allowZero: false, showError: false, returnValue: (data) => {
                                setStockQuantityCallback(data, true);
                            }, isBuyForm: isBuyForm }) })), _jsxs("div", Object.assign({ className: `${styles.priceInput}` }, { children: [_jsx("div", Object.assign({ className: "d-flex justify-content-between align-items-center mb-2 h-15" }, { children: _jsx("label", { children: "Trigger Price" }) })), _jsx("input", { type: "number", placeholder: "Intial Trigger Price", className: `${styles.formControl} ${itpErrorMessage && styles.inputError} form-controlBkp`, value: initialTriggerPrice, onWheel: (event) => {
                                    event.target.blur();
                                }, onChange: (event) => {
                                    setInitialTriggerPriceCallBack(event.target.value);
                                }, disabled: isLegOrder, "aria-label": "", step: ".05" })] }))] })), _jsxs("div", Object.assign({ className: `${styles.errorWrapper} d-flex justify-content-between mt-1 }` }, { children: [_jsxs("p", Object.assign({ className: `${styles.errorText} ${styles.errorTextLeft}` }, { children: [stockQtyErrorMessage && _jsx("span", { className: "errorIcon me-1" }), stockQtyErrorMessage] })), _jsxs("p", Object.assign({ hidden: itpErrorMessage == "", className: `${styles.errorText} ${styles.errorTextRight}` }, { children: [itpErrorMessage && _jsx("span", { className: "errorIcon me-1" }), itpErrorMessage] }))] })), _jsxs("div", Object.assign({ className: `${styles.priceInput} ${styles.priceInputVtt} mt-3` }, { children: [_jsxs("div", Object.assign({ className: "d-flex justify-content-between align-items-center mb-2" }, { children: [_jsx("label", { children: "Price" }), _jsxs("div", Object.assign({ className: `${styles.marketLimit}` }, { children: [_jsx("span", Object.assign({ className: priceType == "market" ? styles.active : "", onClick: () => {
                                            if (!isLegOrder) {
                                                onPriceTypeChange("market");
                                                const inputElement = document.querySelector(".disabled-input");
                                                inputElement.style.pointerEvents = "none";
                                            }
                                        } }, { children: "Market" })), _jsx("span", Object.assign({ className: priceType == "limit" ? styles.active : "", onClick: () => {
                                            if (!isLegOrder) {
                                                onPriceTypeChange("limit");
                                            }
                                        } }, { children: "Limit" }))] }))] })), _jsx("div", Object.assign({ className: "input-groupBkp", onClick: () => {
                            if (!isLegOrder) {
                                onPriceTypeChange("limit");
                                const inputElement = document.querySelector(".disabled-input");
                                inputElement.style.pointerEvents = "auto";
                            }
                        } }, { children: _jsx("input", { type: "number", placeholder: "Market Price", className: `${styles.formControl} ${priceErrorMessage && styles.inputError} form-controlBKp disabled-input`, "aria-label": "", disabled: priceType == "market" || isLegOrder, value: price + "", onWheel: (event) => {
                                event.target.blur();
                            }, step: ".05", onChange: (event) => onPriceChange(event.target.value), style: { pointerEvents: "none" } }) })), _jsxs("p", Object.assign({ className: `${styles.errorText} mt-2 mb-0`, hidden: priceErrorMessage == "" }, { children: [priceErrorMessage && _jsx("span", { className: "errorIcon me-1" }), priceErrorMessage] }))] })), _jsxs("div", Object.assign({ className: `${styles.addStoplossPanel}` }, { children: [_jsxs("div", Object.assign({ className: "d-flex justify-content-between align-items-end" }, { children: [_jsx("label", Object.assign({ className: `${styles.switchTitle} mediumWeight` }, { children: "Add Stoploss" })), _jsx(SwitchButton, { onChange: onAddStoplossChange, checked: addStoplossExpand })] })), addStoplossExpand && (_jsxs("div", Object.assign({ className: `${styles.stopLossPrice} mt-3` }, { children: [_jsxs("div", Object.assign({ className: `${styles.stopLossLeft}` }, { children: [_jsx("div", Object.assign({ className: "d-flex justify-content-between align-items-center h-15" }, { children: _jsx("label", { children: "Stoploss Trigger" }) })), _jsx("input", { type: "number", placeholder: "Stop loss trigger price", className: `${styles.formControl} form-control-bk mt-2`, "aria-label": "", value: stopLossTriggerPrice + "", step: ".05", onWheel: (event) => {
                                            event.target.blur();
                                        }, onChange: (event) => setStopLossTriggerCallback(event.target.value) })] })), _jsxs("div", Object.assign({ className: `${styles.stopLossRight}` }, { children: [_jsxs("div", Object.assign({ className: "d-flex justify-content-between align-items-center h-15" }, { children: [_jsx("label", { children: "Stoploss Price" }), _jsxs("div", Object.assign({ className: `${styles.marketLimit}` }, { children: [_jsx("span", Object.assign({ className: stopLossPriceType == "market" ? styles.active : "", onClick: () => onStopLossPriceTypeChange("market") }, { children: "Market" })), _jsx("span", Object.assign({ className: stopLossPriceType == "limit" ? styles.active : "", onClick: () => onStopLossPriceTypeChange("limit") }, { children: "Limit" }))] }))] })), _jsx("div", Object.assign({ className: "input-group-bk mt-2", onClick: () => {
                                            onStopLossPriceTypeChange("limit");
                                        } }, { children: _jsx("input", { type: "number", placeholder: "Stop loss price", value: stopLossPrice + "", className: `${styles.formControl} form-control-bk`, "aria-label": "", onWheel: (event) => {
                                                event.target.blur();
                                            }, disabled: stopLossPriceType == "market", onChange: (event) => {
                                                setStopLossPriceCallBack(event.target.value);
                                            }, step: ".05" }) }))] }))] })))] })), _jsxs("div", Object.assign({ className: `${styles.addTargetPanel}` }, { children: [_jsxs("div", Object.assign({ className: "d-flex justify-content-between align-items-end mt-1" }, { children: [_jsx("label", Object.assign({ className: `${styles.switchTitle} mediumWeight` }, { children: "Add Target" })), _jsx(SwitchButton, { onChange: onAddTargetChange, checked: addTargetExpand })] })), addTargetExpand && (_jsxs("div", Object.assign({ className: `${styles.stopLossPrice} mt-3` }, { children: [_jsxs("div", Object.assign({ className: `${styles.stopLossLeft}` }, { children: [_jsx("div", Object.assign({ className: "d-flex justify-content-between align-items-center h-15" }, { children: _jsx("label", { children: "Target Trigger" }) })), _jsx("input", { type: "number", placeholder: "Target trigger", className: `${styles.formControl} form-control-bk mt-2`, "aria-label": "", onWheel: (event) => {
                                            event.target.blur();
                                        }, value: targetTriggerPrice + "", onChange: (event) => {
                                            setTargetPriceTriggerCallBack(event.target.value);
                                        }, step: ".05" })] })), _jsxs("div", Object.assign({ className: `${styles.stopLossRight}` }, { children: [_jsxs("div", Object.assign({ className: "d-flex justify-content-between align-items-center h-15" }, { children: [_jsx("label", { children: "Target Price" }), _jsxs("div", Object.assign({ className: `${styles.marketLimit}` }, { children: [_jsx("span", Object.assign({ className: targetPriceType == "market" ? styles.active : "", onClick: () => onTargePriceTypeChange("market") }, { children: "Market" })), _jsx("span", Object.assign({ className: targetPriceType == "limit" ? styles.active : "", onClick: () => onTargePriceTypeChange("limit") }, { children: "Limit" }))] }))] })), _jsx("div", Object.assign({ className: "input-group-bk mt-2", onClick: () => onTargePriceTypeChange("limit") }, { children: _jsx("input", { type: "number", placeholder: "Target price", className: `${styles.formControl} form-control-bk`, "aria-label": "", onWheel: (event) => {
                                                event.target.blur();
                                            }, disabled: targetPriceType == "market", value: targetPrice + "", onChange: (event) => {
                                                setTargetPriceCallBack(event.target.value);
                                            }, step: ".05" }) }))] }))] }))), _jsx(Modal, Object.assign({ isOpen: validationErrorMessage != undefined, onRequestClose: () => {
                            setValidationErrorMessage(undefined);
                        }, className: `${styles.myCommonModal} ${styles.asmGsmModalWrapper} asmGsmModalWrapper`, overlayClassName: styles.myCommonOverlay }, { children: _jsxs("div", Object.assign({ className: `${styles.asmGsmModalInner}` }, { children: [_jsx("p", { children: validationErrorMessage }), _jsx("div", Object.assign({ className: "buttonWrapper buttonWrapperLarge mt-4" }, { children: _jsx("button", Object.assign({ className: "btnType2 me-2", onClick: () => {
                                            setValidationErrorMessage(undefined);
                                        } }, { children: "Close" })) }))] })) }))] }))] }));
};
export default VttBuyForm;
